export const STATUS = {
  overdue: { label: "Overdue", tone: "red" },
  due_this_month: { label: "Due this month", tone: "amber" },
  due_soon: { label: "Due in 60 days", tone: "amber" },
  on_track: { label: "On track", tone: "green" },
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");

export const ErrorText = ({ error, testid }) => (error ? <p role="alert" className="font-bold" style={{ color: "var(--rag-red-fg)" }} data-testid={testid}>{error}</p> : null);

export const Panel = ({ id, eyebrow, title, action, children, className = "" }) => (
  <section id={id} aria-labelledby={`${id}-title`} className={`scroll-mt-[150px] rounded-[2rem] border-2 border-line bg-surface p-5 sm:p-8 ${className}`}>
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
        <h2 id={`${id}-title`} className="font-display text-3xl font-medium sm:text-4xl">{title}</h2>
      </div>
      {action}
    </div>
    {children}
  </section>
);

export const SelectField = ({ id, label, value, onChange, options, testid }) => (
  <div className="flex flex-col gap-1.5">
    <label htmlFor={id} className="field-label">{label}</label>
    <select id={id} value={value} onChange={(e) => onChange(e.target.value)} className="field-input" data-testid={testid}>
      {options.map((o) => <option key={o} value={o}>{o || "Choose…"}</option>)}
    </select>
  </div>
);

export const Confirm = ({ id, checked, onChange, testid, children }) => (
  <label htmlFor={id} className="flex cursor-pointer items-start gap-3 rounded-2xl border-2 border-line bg-paper p-4 font-bold">
    <input id={id} type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-1 h-5 w-5 shrink-0 accent-[var(--brand)]" data-testid={testid} />
    <span>{children}</span>
  </label>
);

export const PseudoNotice = () => (
  <p className="rounded-2xl border-2 p-4 text-sm font-bold" style={{ borderColor: "var(--rag-amber-fg)", background: "var(--rag-amber)", color: "var(--rag-amber-fg)" }} data-testid="pseudo-notice">
    Company policy: all child information must be pseudonymised. Use pupil reference codes only (for example P-0423). Never enter names, dates of birth, addresses, UPNs or photos of children.
  </p>
);
